const validCharsRegex = "^[\x00-\x7F\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF ]*$";

export function isValidInput(input: string): boolean {
    const numChars = input.match(validCharsRegex);
    if (numChars) {
        return numChars.length > 0;
    }
    return false;
}
